import styles from './BetaBadge.module.scss'

const BetaBadge = () => <span className={styles.BetaBadge}>Beta</span>

export default BetaBadge
